export { default } from "./getMinimumDateForReports";
